import React from 'react';
import { Typography, Flex, theme } from 'antd';

type SetupChecklistProgressProps = {
  totalItems: number;
  completedItems: number;
};

function SetupChecklistProgress({ totalItems, completedItems }: SetupChecklistProgressProps) {
  const { token } = theme.useToken();
  const steps = React.useMemo(
    () => Array.from({ length: totalItems }, (_, index) => index < completedItems),
    [totalItems, completedItems]
  );

  return (
    <Flex justify="space-between" align="center">
      <Flex gap={token.sizeXXS} style={{ flex: 1 }}>
        {steps.map((step, index) => (
          <div
            key={index}
            style={{
              flex: 1,
              height: 8,
              borderRadius: token.borderRadius,
              backgroundColor: step ? token.colorPrimary : token.colorFillSecondary,
              transition: 'background-color 0.3s ease',
            }}
          />
        ))}
      </Flex>
      <Typography.Text type="secondary" style={{ marginLeft: token.marginMD }}>
        {completedItems} of {totalItems} completed
      </Typography.Text>
    </Flex>
  );
}

export default SetupChecklistProgress;
